// Archivo generado automáticamente en cada compilación (npm run build)
export const APP_VERSION = "v0.1.97";
